import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuickAddShortcut } from '@/src/renderer/hooks/useQuickAddShortcut'
import { detectOS, isWeb } from '@/src/renderer/lib/platform/detection'
import { quickAddShortcutText } from '@/src/renderer/components/layout/Titlebar/controls/QuickAddButton'

/** Woran die Texte der Einführung hängen: Web oder App, und das eingestellte Kürzel der Schnelleingabe. */
export function useIntroTextOptions(): { web: boolean; quickAddKeys: string } {
  const { t } = useTranslation()
  const { shortcut } = useQuickAddShortcut()
  return useMemo(() => ({
    web: isWeb(),
    // Im Fließtext ausgeschrieben: „⌥␣“ steht im Tooltip als Taste, in einem Satz läse es sich als Tippfehler.
    quickAddKeys: quickAddShortcutText(shortcut, detectOS() === 'mac').replace('␣', ` ${t('intro.spaceKey')}`),
  }), [shortcut, t])
}
